import { computed } from 'mobx';
import useMount from '@src/utils/hooks/use-mount';
import BaseStore from '@src/utils/store/base-store';
import $$tracker from '@src/tracker';
import { SHARE_METHOD_CONFIG } from '@src/constants/business';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
import { getLocales } from '@src/global-locales/get-page-locales-data';
import { copyToClipboard } from '@src/utils/common-util';
import message from '@src/components/common-message';
const lang = getLanguageByPath();

/*
英：https://gm-mobile.amazingseasun.com/app/h5/jxj/en-US/index
日：https://gm-mobile.amazingseasun.com/app/h5/jxj/ja-JP/index
韩：https://gm-mobile.amazingseasun.com/app/h5/jxj/ko-KR/index
繁：https://gm-mobile.amazingseasun.com/app/h5/jxj/zh-TW/index
西：https://gm-mobile.amazingseasun.com/app/h5/jxj/es-ES/index
葡：https://gm-mobile.amazingseasun.com/app/h5/jxj/pt-PT/index
德：https://gm-mobile.amazingseasun.com/app/h5/jxj/de-DE/index
法：https://gm-mobile.amazingseasun.com/app/h5/jxj/fr-FR/index
俄：https://gm-mobile.amazingseasun.com/app/h5/jxj/ru-RU/index
泰：https://gm-mobile.amazingseasun.com/app/h5/jxj/th-TH/index
*/
const CUSTOMER_SERVICE_LINK = {
  en: 'https://gm-mobile.amazingseasun.com/app/h5/jxj/en-US/index',
  ja: 'https://gm-mobile.amazingseasun.com/app/h5/jxj/ja-JP/index',
  ko: 'https://gm-mobile.amazingseasun.com/app/h5/jxj/ko-KR/index',
  'zh-Hant': 'https://gm-mobile.amazingseasun.com/app/h5/jxj/zh-TW/index',
  es: 'https://gm-mobile.amazingseasun.com/app/h5/jxj/es-ES/index',
  pt: 'https://gm-mobile.amazingseasun.com/app/h5/jxj/pt-PT/index',
  de: 'https://gm-mobile.amazingseasun.com/app/h5/jxj/de-DE/index',
  fr: 'https://gm-mobile.amazingseasun.com/app/h5/jxj/fr-FR/index',
  ru: 'https://gm-mobile.amazingseasun.com/app/h5/jxj/ru-RU/index',
  th: 'https://gm-mobile.amazingseasun.com/app/h5/jxj/th-TH/index'
};

class EighthPageStore extends BaseStore {
  @computed
  get itemList() {
    return SHARE_METHOD_CONFIG.filter(item => item.applyLanguages.includes(lang))
      .sort((a, b) => a.order[lang] - b.order[lang])
      .map(item => ({
        name: item.name,
        link: item.linkLocales[lang],
        img: require(`./images/${item.name}.png`),
        activeImg: require(`./images/${item.name}-active.png`),
        onClick: item.onClick
      }));
  }

  @computed
  get customerServiceLink() {
    return CUSTOMER_SERVICE_LINK[lang];
  }

  copyEmail = async () => {
    try {
      await copyToClipboard('press@seasungames.com');
      message.success(getLocales('gift.copy_success_tips_text'));
    } catch (error) {
      message.fail(getLocales('gift.copy_error_tips_text'));
    }
  };

  use() {
    useMount(() => {});
  }
}
export default EighthPageStore;
